import { ICadType } from '../models/document/cad-type.model';
import { IDocumentTypeText } from '../models/document/document-type-text.model';
import { IDocumentType } from '../models/document/document-type.model';
import { IExportSettingsFe } from '../models/export/export-settings-fe.model';
import { IProductItem } from '../models/item/product-item.model';
import { ILanguagesContainer } from '../models/language/languages-container.model';
import { ISession } from '../models/session/session.models';

export interface MydocState {
  session: ISession;
  language: ILanguagesContainer;
  exportSettings: IExportSettingsFe;
  currentStep: number;
  selectedDocumentTypes: IDocumentTypeText[];
  availableDocumentTypes: IDocumentType[];
  selectedCadTypes: ICadType[];
  availableCadTypes: ICadType[];
  selectedProducts: IProductItem[];
  needToSaveSettings: boolean;
  showErrorMessage: boolean;
}

export const initialMydocState: MydocState = {
  session: {
    id: null,
    orderNumber: null,
    language: null,
    documentSession: null,
  },
  language: {
    available: [],
    selected: [],
  },
  exportSettings: {
    showExportSettingsTooltip: true,
    availableConfiguration: null,
    defaultConfiguration: null,
    savedConfiguration: null,
  },
  currentStep: 0,
  selectedDocumentTypes: [],
  selectedCadTypes: [],
  availableDocumentTypes: [],
  availableCadTypes: [],
  selectedProducts: [],
  needToSaveSettings: false,
  showErrorMessage: false,
};
